import React from 'react';
import { MOBILE_BREAKPOINT } from '@maverick/utils';
import styled, { css } from 'styled-components';

export const Icon = styled.div<{ isLoading?: boolean }>`
    height: 24px;
    max-width: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all ease 0.1s;
    position: relative;

    & > *:first-child {
        color: ${({ theme }) => theme.orderUi.icons.iconHeaderColor};
    }

    ${({ isLoading }) =>
        isLoading &&
        css`
            cursor: default;

            &:hover {
                opacity: 1;
            }
        `}
`;

export const AnimatedIconContainer = styled(
    Icon as unknown as React.ComponentType<{ isLoading?: boolean } & React.HTMLAttributes<HTMLDivElement>>
)`
    top: -1px;
    height: 14px;
    width: 40px;
`;

export const UserAccount = styled.button`
    background: none;
    border: none;
    padding: 5px 8px;
    color: ${({ theme }) => theme.orderUi.colors.neutral.light};
    cursor: pointer;
    appearance: auto;
    display: inline-block;

    :focus-visible {
        outline: -webkit-focus-ring-color auto 1px;
    }

    @media (max-width: 767px) {
        padding: 5px 8px;
    }
`;

export const UserAccountLink = styled.a`
    background: none;
    border: none;
    padding: 5px 8px;
    color: ${({ theme }) => theme.orderUi.colors.neutral.light};
    cursor: pointer;
    appearance: auto;
    display: inline-block;

    @media (max-width: 767px) {
        padding: 5px 8px;
    }
    text-decoration: none;
    color: inherit;
    display: flex;
    align-items: center;
    cursor: pointer;
`;

export const SignIn = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    color: ${({ theme }) => theme.orderUi.icons.iconHeaderColor};
    border: 1px solid ${({ theme }) => theme.orderUi.icons.iconHeaderColor};
    border-radius: 20px;
    padding: 5px 8px;
    padding-right: 14px;

    &:hover {
        opacity: 0.6;
    }
`;

export const SignInText = styled.span`
    ${({ theme }) => theme.components.profileButton.typography.label.small};
`;

export const PopUpContainer = styled.div`
    color: ${({ theme }) => theme.orderUi.colors.neutral.dark};
    max-width: 273px;

    @media (max-width: ${MOBILE_BREAKPOINT}px) {
        max-width: unset;
    }
`;

export const PopUpTitle = styled.h2`
    ${({ theme }) => theme.orderUi.typography.title.xsmall};
    ${({ theme }) => theme.orderUi.typography.body.large};
    display: block;
    margin-bottom: 18px;
    margin-top: 0;
`;

export const PopUpText = styled.span`
    ${({ theme }) => theme.orderUi.typography.body.small};
    text-align: center;
    display: block;
    margin-bottom: 18px;
`;

export const PopUpButtons = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledLink = styled.a<{
    variant: 'sign-in' | 'join-now';
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-decoration: none !important;
    padding: 8px 0;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 700;
    font-size: 14px;
    line-height: 18px;

    ${({ variant }) =>
        variant === 'sign-in' &&
        css`
            background-color: ${({ theme }) => theme.orderUi.colors.primary.variant};
            border: 2px solid ${({ theme }) => theme.orderUi.colors.primary.variant};
            color: ${({ theme }) => theme.orderUi.colors.neutral.light} !important;

            &:hover,
            &:focus {
                background-color: ${({ theme }) => theme.orderUi.colors.primary.lightVariant};
                border-color: ${({ theme }) => theme.orderUi.colors.primary.lightVariant};
            }
        `}

    ${({ variant }) =>
        variant === 'join-now' &&
        css`
            background-color: transparent;
            border: none;
            color: ${({ theme }) => theme.orderUi.colors.primary.variant} !important;

            &:hover,
            &:focus {
                color: ${({ theme }) => theme.orderUi.colors.primary.lightVariant};
            }
        `}
`;
